/**
 * Common texts - what is CamAPS FX
 */
export const whatIsCamAPSFX = {

    linkFindOutMore: 'Zjistěte více',
    body:
        '<h2>Co je CamAPS FX?</h2> <p> CamAPS FX je mobilní aplikace k řízení hladiny glukózy u lidí s diabetem 1. typu pomocí pokročilé adaptivní hybridní uzavřené smyčky. </p>'
};

/**
 * Common texts - what is CamAPS FX
 */
export const userReviewsIntro = {
    linkMoreReviews: 'Více příběhů',
    readMore: 'Přečtěte si více',
    header:
        'Příběhy uživatelů',
    text:
        'Skuteční lidé. Skutečné zkušenosti.'
};